
import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import OrderInfo from '../../../components/OrderInfo';
import {getOneByTripId} from '../../../store/actions/order';
import * as navigator from '../../../native/navigator';

import './index.css';
import * as selector from '../selector';


class MyCar extends React.Component {
  static propTypes = {
    order: propTypes.object,
    trip_id: propTypes.string.isRequired
  };

  render() {
    let {order} = this.props;

    if (!order) {
      return null;
    }

    return (
      <div className='my-car' onClick={this.handleClick}>
        <div className='section-title'>
          <h2>{order.order_id ? '我的租车' : '租辆车自驾'}</h2>
          {order.order_id ? null : (
            <div>
              <span>去租车</span>
              <i className='icon icon-arrow' />
            </div>
          )}
        </div>
        <div className='content'>
          <div className='pic' style={{
            backgroundImage: `url(${order.car_img})`
          }} />
          <OrderInfo order={order} />
        </div>
      </div>
    );
  }

  componentDidMount() {
    let {trip_id, getOneByTripId} = this.props;

    getOneByTripId(trip_id);
  }

  handleClick = () => {
    // sendStatsEvent('trip_orderDetailsClick');
    let {order} = this.props;
    let url = order.order_url || order.search_url;

    if (url) {
      navigator.push(url);
    }
  };
}

export default connect(function (state, ownProps) {
  return {
    ...ownProps,
    order: selector.order(state)
  };
}, {
  getOneByTripId
})(MyCar);



// WEBPACK FOOTER //
// ./src/pages/trip/MyCar/index.js